export const authenticationQueryKey = {
  base: { scope: "authentication" },
  cloudFrontAuth: () => [
    { ...authenticationQueryKey.base, id: "cloud-front-cookies" },
  ],
};
